/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Save_Changes_ButtonInputs */



/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Team_Manager_Save_Changes_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_changes_button = /** @type {((inputs?: Team_Manager_Save_Changes_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_Changes_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva modifiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить изменения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar cambios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更を保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बदलाव सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guardar alterações")
	return /** @type {LocalizedString} */ ("Save changes")
});